import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {TaskCommentModel, TaskModel} from '../../../models/task.model';
import {CrmService} from '../../../services/api/crm.service';
import {CommentsService} from '../../../services/comments.service';
import {AlertService} from '../../../services/notify/alert.service';
import {MemberModel} from '../../../models/user.model';
import {MemberService} from '../../../services/member.service';
import {ModalService} from '../../../services/modal/modal.service';
import {HelpersService} from '../../../services/helpers.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-task-detail-comments',
    templateUrl: './task-detail-comments.component.html',
    styleUrls: ['./task-detail-comments.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TaskDetailCommentsComponent implements OnInit {
    @Input() public taskData: TaskModel;
    @Input() public key: string | number;
    @Input() public commentsType: string;

    @Input() public canCreateComments: boolean;

    @Output() public emitLoadCommentsCount: EventEmitter<number> = new EventEmitter<number>();

    public taskCommentsData: TaskCommentModel[] = [];

    public isLockButton = false;
    public isShowEditor = false;
    public isEditComment = false;

    public isTaskCommentsLoading = true;

    public selectedComment = {
        data: '',
        id: 0,
        created_at: '',
    };

    comment: string;
    newComment: string;

    public currentUser: MemberModel;

    constructor(
        protected crmService: CrmService,
        protected alertService: AlertService,
        protected memberService: MemberService,
        protected modalService: ModalService,
        protected commentsService: CommentsService,
        public helper: HelpersService,
        public translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.memberService.getCurrentMember().then((result: MemberModel) => {
            this.currentUser = result;
        });
        this.loadComments();
    }

    loadComments(): void {
        this.isShowEditor = false;
        this.commentsService.getCommentsHandler(this.key, this.commentsType).then(res => {
            this.isTaskCommentsLoading = true;
            this.emitLoadCommentsCount.emit(res.length);
            this.taskCommentsData = res;
            this.getMembers();
        });
    }

    getMembers(): void {
        const usersGuids = this.taskCommentsData.map(comment => {
            return comment.member_guid;
        });
        this.memberService.memberGuidsHandler(usersGuids).then(members => {
            this.taskCommentsData.forEach(comment => {
                comment.user = members.find(member => member.guid === comment.member_guid);
            });
        });
    }

    setComment(comment: any): void {
        this.comment = comment.comment;
        this.selectedComment = comment;
        this.isEditComment = true;
    }

    editComment(): void {
        this.isLockButton = true;
        this.comment = this.newComment;
        this.commentsService.editComment(this.commentsType, this.selectedComment.id, this.comment).then(res => {
            this.isLockButton = false;
            this.alertService.setAlert(res.message, 'green');
            this.isEditComment = false;
            this.selectedComment = {
                data: '',
                id: 0,
                created_at: '',
            };
            this.comment = ' ';
            this.newComment = null;
            this.isShowEditor = false;
            void this.loadComments();
        }).catch(error => {
            this.isLockButton = false;
            this.alertService.setAlert(error.message, 'blue');
        });
    }

    sendComment(): void {
        this.isShowEditor = false;
        this.comment = this.newComment;
        const comment: TaskCommentModel = {
            created_at: new Date().toString(),
            member_guid: this.currentUser.guid,
            comment: this.comment,
        };
        this.taskCommentsData.push(comment);

        this.isLockButton = true;
        this.commentsService.createComment(this.commentsType, this.key, this.comment).then(data => {
            this.isLockButton = false;
            this.comment = ' ';
            this.newComment = null;
            this.alertService.setAlert(data.message, 'green');
            void this.loadComments();
        }).catch(err => {
            this.alertService.setAlert(err.message, 'blue');
            this.isLockButton = false;
            void this.loadComments();
        });
    }

    deleteComment(comment: TaskCommentModel): void {
        const modalSettings: any = {
            modalHeader: this.translate.instant('CONFIRM.HEADERS.DELETE'),
            modalBody: this.translate.instant('CONFIRM.TEXT.DELETE_COMMENT'),
            buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
            buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
        };
        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.commentsService.deleteComment(this.commentsType, comment.id).then(res => {
                    this.alertService.setAlert(res.message, 'green');
                    void this.loadComments();
                }).catch(error => {
                    this.alertService.setAlert(error.message, 'blue');
                });
            }
        }).catch(() => {
            return;
        });
    }
}
